import axios from "axios";
import { Urls } from "../slices/urls";
import { BASE_URL } from "../slices/urls";
import {ServiceUrls} from '../serviceUrl'


export const postMedicalCommonAppRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_COMMON_APP_API,
    data: data,
  });
};

export const getMedicalIdpStatusRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_STATUS_API,
    params: params,
  });
};


export const getMedicalFormStatusRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_FORM_STATUS_API,
    params: params,
  });
};

export const getMedicalDegreeRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_DEGREE_API,
    params: params,
  });
};

export const postMedicalDegreeRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_DEGREE_API,
    data: data,
  });
};

export const getMedicalExamRepo = (params, id) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_EXAM_API,
    params: params,
  });
};

export const postMedicalExamRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_EXAM_API,
    data: data,
  });
};

export const getMedicalSpecializationRepo = (params, id) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_SPECIALIZATION_API,
    params: params,
  });
};

export const postMedicalSpecializationRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_SPECIALIZATION_API,
    data: data,
  });
};

export const getMedicalCoachingRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_COACHING_API,
    params: params,
  });
};

export const getMedicalCoachingLocationRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_COACHING_LOCATION_API,
    params: params,
  });
};

export const postMedicalCoachingLocationRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_COACHING_LOCATION_API,
    data: data,
  });
};


export const getMedicalCoachingModeRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_COACHING_MODE_API,
    params: params,
  });
};

export const postMedicalCoachingRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_COACHING_API,
    data: data,
  });
};

//GET_IDP_MEDICAL_COACHING_LIST_API
export const getMedicalCoachingListRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_COACHING_LIST_API,
    params: params,
  });
};

export const postMedicalCoachingListRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_COACHING_LIST_API,
    data: data,
  });
};

export const getMedicalPrefereLocationRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_PREFFERED_LOCATION_API,
    params: params,
  });
};

export const postMedicalPrefereLocationRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_PREFFERED_LOCATION_API,
    data: data,
  });
};

export const getMedicalPrefereCollegeRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_PREFFERED_INSTITUTE_API,
    params: params,
  });
};
export const postMedicalPrefereCollegeRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_PREFFERED_INSTITUTE_API,
    data: data,
  });
};

//Product
export const getMedicalProductRepo = (params, id) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_PRODUCT_API,
    params: params,
  });
};
export const postMedicalProductRepo = (data) => {
  return axios({  
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_PRODUCT_API,
    data: data,
  });
};

//Other specialization
export const getMedicalOtherSpecializationRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_OTHER_SPECIALIZATION_API,
    params: params,
  });
};
export const postMedicalOtherSpecializationRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_OTHER_SPECIALIZATION_API,
    data: data,
  });
};

export const getMedicalTopCollegeRepo = (params, id) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_MEDICAL_COLLEGE_API,
    params: params,
  });
};
export const postMedicalTopCollegeRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_IDP_MEDICAL_COLLEGE_API,
    data: data,
  });
};

export const postMedicalLeadCreateRepo = (data) => {
  return axios({
    method: "POST",
    baseURL: window.origin,
    url: Urls.GET_IDP_LEAD_CREATE_API,
    data: data,
  });
};

export const postMedicalFormSubmitRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_MEDICAL_SUBMIT_API,
    data: data,
  });
};
